var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.PricesListCard,
    {
      attrs: {
        "show-all-href": _vm.showAllHref,
        "list-qa": "lpu_services_service_list",
        "more-qa": "lpu_services_btn-more",
      },
    },
    _vm._l(_vm.services, function (service, index) {
      return _c(_setup.PricesServiceRow, {
        key: service.id ?? service.synonym_id,
        attrs: {
          service: service,
          "is-striped": index % 2 === 1,
          "is-calendar-open": _setup.openedSynonymId === service.synonym_id,
          "lpu-id": _vm.lpuId,
          "town-timedelta": _vm.townTimedelta,
        },
        on: {
          "open-calendar": function ($event) {
            _setup.openedSynonymId = $event.synonym_id
          },
          "close-calendar": function ($event) {
            _setup.openedSynonymId = null
          },
          "empty-schedule": function ($event) {
            return _setup.emit("empty-schedule", $event)
          },
          slot: _setup.onSlot,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }